export const SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO = 6;

export const PRAGAS_RETENCAO_ALEM_DO_TEMPO = 7;

export const PRAGAS_DESCARGA_ZERO = 8;

export const PRAGAS_RESTRICAO_VOLUME = 9;

export const WorkflowTypes = {
  SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO: SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO,
  PRAGAS_RETENCAO_ALEM_DO_TEMPO: PRAGAS_RETENCAO_ALEM_DO_TEMPO,
  PRAGAS_DESCARGA_ZERO: PRAGAS_DESCARGA_ZERO,
  PRAGAS_RESTRICAO_VOLUME: PRAGAS_RESTRICAO_VOLUME,
};

export const Workflow: Record<number, string> = {
  [SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO]: "Pedido Emergencial",
  [PRAGAS_RETENCAO_ALEM_DO_TEMPO]: "Retenção Além do Tempo",
  [PRAGAS_DESCARGA_ZERO]: "Descarga Zero",
  [PRAGAS_RESTRICAO_VOLUME]: "Restrição de Volume",
};

export const WorkflowMessage: Record<number, string> = {
  [SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO]:
    "Os pedidos que chegam na Central de Relacionamento em caráter emergencial serão cobrados caso sejam atendidos em até 2 dias úteis.",
  [PRAGAS_RETENCAO_ALEM_DO_TEMPO]:
    "A retenção além do tempo é caracterizada pelo tempo de permanência no site do cliente além do tempo de baseline. A retenção será cobrada em cima das horas cheias com tolerância de 30 min.",
  [PRAGAS_RESTRICAO_VOLUME]:
    "Atenção: este evento foi identificado pelo motorista. É importante a sua validação antes de aprovar para evitar cobrança indevida para o cliente.",
};

export const WorkflowToEventType: Record<number, string> = Workflow;

export const EventTypeToWorkFlow: Record<string, number> = Object.assign(
  {},
  ...Object.entries(Workflow).map(([a, b]) => ({ [b]: a }))
);
